module.exports = __webpack_public_path__ + "img/bench.20f824ac.png";